import WithNavigation from 'src/layouts/WithNavigation/WithNavigation';

interface ErrorDisplayProps {
  title: string;
  message: string;
  onRetry: () => void;
  buttonText: string;
  colorScheme?: 'red' | 'yellow';
  pageTitle?: string;
}

const ErrorDisplay = ({
  title,
  message,
  onRetry,
  buttonText,
  colorScheme = 'red',
  pageTitle = 'Error',
}: ErrorDisplayProps) => {
  const colors = {
    red: {
      bg: 'bg-red-50',
      border: 'border-red-200',
      titleText: 'text-red-800',
      messageText: 'text-red-700',
      button: 'bg-red-600 hover:bg-red-700',
    },
    yellow: {
      bg: 'bg-yellow-50',
      border: 'border-yellow-200',
      titleText: 'text-yellow-800',
      messageText: 'text-yellow-700',
      button: 'bg-yellow-600 hover:bg-yellow-700',
    },
  };

  const scheme = colors[colorScheme];

  return (
    <WithNavigation
      title={pageTitle}
      top={
        <div className={`p-4 ${scheme.bg} border ${scheme.border} rounded-md`}>
          <h3 className={`text-lg font-medium ${scheme.titleText}`}>{title}</h3>
          <p className={`mt-2 ${scheme.messageText}`}>{message}</p>
          <button
            onClick={onRetry}
            className={`mt-3 px-4 py-2 ${scheme.button} text-white rounded`}
          >
            {buttonText}
          </button>
        </div>
      }
      bottom={<div />}
    />
  );
};

export default ErrorDisplay;
